import useSWR, { mutate } from 'swr';
import { CACHE_KEYS } from '@/constants/cache-keys';
import { AdminSettingsService } from '@/services/engine/admin-settings-service';
import type { OrganizationConfiguration } from '@/types/admin-settings';

export function useConfiguration() {
    const { data, isLoading, error, mutate } =
        useSWR<OrganizationConfiguration>(
            CACHE_KEYS.ADMIN_ORGANIZATION_CONFIGURATION,
            () => AdminSettingsService.getOrganizationConfiguration(),
            { revalidateOnFocus: false },
        );

    return { configuration: data, isLoading, error, mutate };
}

export function revalidateOrganizationConfiguration() {
    return Promise.all([
        mutate(CACHE_KEYS.ADMIN_ORGANIZATION_CONFIGURATION),
        mutate(CACHE_KEYS.ADMIN_FEATURE_FLAGS),
    ]);
}

export function revalidateAlertUnitCapacity() {
    return mutate(
        (key) =>
            key === CACHE_KEYS.ALERT_UNIT_CAPACITY ||
            (Array.isArray(key) && key[0] === CACHE_KEYS.ALERT_UNIT_CAPACITY),
    );
}

export function revalidateFeatureFlags() {
    return mutate(CACHE_KEYS.ADMIN_FEATURE_FLAGS);
}
